import emma from '@/common/services/Emma'

const TransactionsResource = {
	postOperation (operation) { return emma.post('api/mission/add', operation) },
	updateOperation (id, operation) { return emma.post('api/mission/add/' + id, operation) },
	getOperations () { return emma.get('api/mission') },
	getOperation (id) { return emma.get('api/mission/' + id) },
	getContracts () { return emma.get('api/contract') },
	createContract (contract) { return emma.post('api/contract/add', contract) },
	getProducts () { return emma.get('api/product') },
	createProduct (product) { return emma.post('api/product/add', product) },
	linkProductToContract (contractId, productId) {
		return emma.post('api/product-contract', {
			contract_id: contractId,
			product_id: productId
		})
	},
	addProductToMission (data) { return emma.post('api/mission-contract-product', data) },
	editProductFromMission (data) { return emma.post('api/mission-contract-product', data) },
	removeProductFromMission (id) { return emma.get('api/delete-mission-contract-product/' + id) }
}

export default TransactionsResource



// WEBPACK FOOTER //
// ./src/common/resources/Transactions.js